import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dev-group-func-host]',
    standalone: false
})
export class DeviceGroupFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}